import { useState } from "react";
import { Reveal } from "../components/Reveal";
import { GALLERY, REAL_LIFE } from "../lib/assets";
import { Gift, Users, Share2 } from "lucide-react";
import { toast } from "sonner";

export default function Community() {
  const [email, setEmail] = useState("");

  const programs = [
    { icon: Users, title: "Ambassador Program", copy: "Represent SV, earn commission, and get early access to every drop. For instructors, athletes, and creators." },
    { icon: Share2, title: "Referral Program", copy: "Give friends $20, get $20. Share your confidence and be rewarded for it." },
    { icon: Gift, title: "SV Rewards", copy: "Earn points on every purchase, review, and referral. Redeem for products, perks, and VIP experiences." },
  ];

  return (
    <div data-testid="community-page">
      <section className="bg-sage/20 py-20">
        <div className="container-luxe text-center max-w-2xl mx-auto">
          <p className="overline text-gold mb-3">The SV Community</p>
          <h1 className="h-display text-5xl sm:text-7xl mb-5">Stronger Together</h1>
          <p className="text-sm text-muted-foreground font-light">A community of women who move with confidence — and lift each other higher.</p>
        </div>
      </section>

      <section className="container-luxe py-24 grid grid-cols-1 md:grid-cols-3 gap-8">
        {programs.map(({ icon: Icon, title, copy }, i) => (
          <Reveal key={title} delay={i * 0.1}>
            <div className="border border-hairline p-10 h-full flex flex-col" data-testid={`program-${i}`}>
              <Icon size={28} strokeWidth={1.2} className="text-gold mb-6" />
              <h3 className="font-serif text-2xl mb-3">{title}</h3>
              <p className="text-sm text-muted-foreground font-light leading-relaxed flex-1">{copy}</p>
              <button className="btn-secondary mt-8 self-start" data-testid={`program-join-${i}`} onClick={() => toast.success("Thanks! We'll be in touch soon.")}>Join Now</button>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="bg-charcoal text-bone py-24">
        <div className="container-luxe text-center max-w-3xl mx-auto">
          <p className="overline text-gold mb-6">SV Athletic Wear</p>
          <h2 className="h-display text-4xl sm:text-5xl mb-8">{REAL_LIFE.heading}</h2>
          <p className="font-serif text-xl sm:text-2xl font-light leading-relaxed text-bone/85">{REAL_LIFE.copy}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container-luxe mb-8"><p className="overline text-gold mb-3">@svathleticwear</p><h2 className="h-display text-4xl sm:text-5xl">Tag Us To Be Featured</h2></div>
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 px-2">
          {GALLERY.map((src, i) => (
            <div key={i} className="aspect-square overflow-hidden bg-beige/40 group"><img src={src} alt="community" loading="lazy" className="h-full w-full object-cover img-zoom" /></div>
          ))}
        </div>
      </section>

      <section className="container-luxe py-24 text-center max-w-xl mx-auto">
        <h2 className="h-display text-4xl sm:text-5xl mb-6">Join The List</h2>
        <p className="text-sm text-muted-foreground font-light mb-8">Early access, exclusive offers, and stories worth reading.</p>
        <form onSubmit={(e) => e.preventDefault()} className="flex max-w-md mx-auto border-b border-charcoal" data-testid="community-newsletter">
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" disabled placeholder="Email address" className="flex-1 bg-transparent py-4 outline-none text-sm disabled:opacity-60 disabled:cursor-not-allowed" />
          <button type="submit" disabled className="overline text-[11px] px-4 disabled:opacity-70 disabled:cursor-not-allowed">Coming Soon</button>
        </form>
      </section>
    </div>
  );
}
